module.exports = __webpack_public_path__ + "static/media/6a_website_logo_Platinum_che.b1c3959d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/6a_website_logo_Platinum_che.jpg
// module id = 96
// module chunks = 0